
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-d420b0f2&scoped=true!../node_modules/vue-loader/lib/selector?type=styles&index=0!./ForgotPasswordPage.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./ForgotPasswordPage.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-d420b0f2!../node_modules/vue-loader/lib/selector?type=template&index=0!./ForgotPasswordPage.vue"),
  /* scopeId */
  "data-v-d420b0f2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/ForgotPasswordPage.vue
// module id = 284
// module chunks = 2